import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import React from 'react';
import { AlertSimpleError } from '../../alert/alert-simple/alert-simple-error';
var CheckboxCardGroup = function CheckboxCardGroup(_ref) {
  var variant = _ref.variant,
    disabled = _ref.disabled,
    reversed = _ref.reversed,
    errorMessage = _ref.errorMessage,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["variant", "disabled", "reversed", "errorMessage", "children"]);
  var childrenWithProps = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      variant: variant,
      reversed: reversed
    });
  });
  return jsx("div", _extends({}, props, {
    sx: _objectSpread(_objectSpread(_objectSpread({}, CheckboxCardGroupStyles.container), props.reversed && CheckboxCardGroupStyles.containerReversed), props.sxOverrides)
  }), childrenWithProps, errorMessage && jsx(AlertSimpleError, null, errorMessage));
};
var CheckboxCardGroupStyles = {
  container: {
    padding: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  containerReversed: {
    alignItems: 'flex-end'
  }
};
export { CheckboxCardGroup };